import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Input, ViewChild } from "@angular/core";
import { AppState } from "../../../app.service";
import { BasketAssistant } from "@api/services/basket";
import { formatEuro, formatPercent } from "@api/utils";
import { findOneById } from "@api/services/products";
import { SERVICE_TYPE_DATA_VOLUME_BENEFIT, SERVICE_TYPE_DEVICE_INSURANCE, } from "@api/schema/offer";
import { VluxMarkup, getPromoSubprices } from "@api/utils";
import { ActionDialogComponent } from "app/shared/components/action-dialog";
var BasketItemComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function BasketItemComponent(appState) {
        this.appState = appState;
        /**
         * Set our default values
         */
        this.localState = { value: "" };
        this.formatEuro = formatEuro;
        this.formatPercent = formatPercent;
        this.previewUrl = "/simplicity/assets/img/ecommerce/icon-simonly-basket.png";
        this.openDeleteItemDialog = "hidden";
        this.components = [];
        this.mandatoryServices = [];
        this.usedOptions = [];
        this.insuranceOption = [];
        this.discounts = [];
        this.voucherBenefits = [];
        this.onetimeCashback = "";
        this.onetimeVoucherBenefits = [];
        this.amount = "1";
        this.benefits = [];
        this.VluxMarkup = VluxMarkup;
        this.promoSubprice = "";
        this.handleConfirmDeleteItem = this.handleConfirmDeleteItem.bind(this);
        this.handleAbortDeleteItem = this.handleAbortDeleteItem.bind(this);
    }
    BasketItemComponent.prototype.ngOnInit = function () {
        if (this.basketItem.offer.components) {
            this.loadPreview();
            this.calculatePromoPrice();
        }
    };
    BasketItemComponent.prototype.calculatePromoPrice = function () {
        var promoPrices = getPromoSubprices(this.basketItem.offer);
        var promoPriceLabel = "";
        for (var _i = 0, promoPrices_1 = promoPrices; _i < promoPrices_1.length; _i++) {
            var subprice = promoPrices_1[_i];
            var price = subprice.price;
            if (subprice.runtime < 24 && subprice.runtime > 2) {
                promoPriceLabel = promoPriceLabel + " Ab dem " + subprice.runtime + ". Monat " + formatEuro(price * this.basketItem.amount) + " <br>";
            }
            else {
                promoPriceLabel = "";
            }
        }
        return promoPriceLabel;
    };
    BasketItemComponent.prototype.handleConfirmDeleteItem = function () {
        this.delete();
        this.openDeleteItemDialog = "hidden";
    };
    BasketItemComponent.prototype.handleAbortDeleteItem = function () {
        this.openDeleteItemDialog = "hidden";
    };
    BasketItemComponent.prototype.getComponents = function () {
        function compare(a, b) {
            if (a.type < b.type) {
                return -1;
            }
            if (a.type > b.type) {
                return 1;
            }
            return 0;
        }
        this.basketItem.offer.components.sort(compare);
        return this.basketItem.offer.components;
    };
    BasketItemComponent.prototype.submitState = function (value) { };
    BasketItemComponent.prototype.increase = function () {
        BasketAssistant.increment(this.basketItem);
    };
    BasketItemComponent.prototype.decrease = function () {
        if (this.basketItem.amount === 1) {
            this.actionDialog.open();
            return;
        }
        BasketAssistant.decrement(this.basketItem);
    };
    BasketItemComponent.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, BasketAssistant.removeItem(this.basketItem)];
                    case 1:
                        _a.sent();
                        if (navigator.appName === "Microsoft Internet Explorer" ||
                            !!(navigator.userAgent.match(/Trident/) ||
                                navigator.userAgent.match(/rv:11/))) {
                            window.location.reload();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketItemComponent.prototype.hasMonthlyPrice = function (prices) {
        for (var _i = 0, prices_1 = prices; _i < prices_1.length; _i++) {
            var price = prices_1[_i];
            if (price.recurrenceUnit === "month") {
                return true;
            }
        }
        return false;
    };
    BasketItemComponent.prototype.isPercentage = function (prices) {
        for (var _i = 0, prices_2 = prices; _i < prices_2.length; _i++) {
            var price = prices_2[_i];
            if (price.type === "percentage") {
                return true;
            }
        }
        return false;
    };
    BasketItemComponent.prototype.getMonthlyPrice = function (prices) {
        for (var _i = 0, prices_3 = prices; _i < prices_3.length; _i++) {
            var price = prices_3[_i];
            if (price.recurrenceUnit === "month") {
                return price.value;
            }
        }
        return 0;
    };
    BasketItemComponent.prototype.hasOnetimePrice = function (prices) {
        for (var _i = 0, prices_4 = prices; _i < prices_4.length; _i++) {
            var price = prices_4[_i];
            if (price.recurrenceUnit === "onetime") {
                return true;
            }
        }
        return false;
    };
    BasketItemComponent.prototype.getOnetimePrice = function (prices) {
        for (var _i = 0, prices_5 = prices; _i < prices_5.length; _i++) {
            var price = prices_5[_i];
            if (price.recurrenceUnit === "onetime") {
                return price.value;
            }
        }
        return 0;
    };
    BasketItemComponent.prototype.getDeviceMonthlyPrice = function () {
        var monthlyPrice = this.basketItem.offer.getMonthlyPrice();
        var mandatorySum = this.basketItem.offer.getMonthlyDiscountSum();
        var usedOptionsSum = this.basketItem.offer.getMonthlyOptionsSum();
        var tariffPrice;
        for (var _i = 0, _a = this.basketItem.offer.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.type === "tariffMobile") {
                tariffPrice = this.getMonthlyPrice(component.prices);
            }
        }
        return ((monthlyPrice - mandatorySum - usedOptionsSum - tariffPrice) *
            this.basketItem.amount);
    };
    BasketItemComponent.prototype.loadPreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _i, _a, component, product, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _i = 0, _a = this.basketItem.offer.components;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length))
                            return [3 /*break*/, 6];
                        component = _a[_i];
                        if (!(component.type === "hardwareMobile"))
                            return [3 /*break*/, 5];
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, findOneById(component.refId)];
                    case 3:
                        product = _b.sent();
                        this.previewUrl =
                            "https://eweb8.vfd2-testnet.de" + product.getImages().large;
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        this.delete();
                        return [3 /*break*/, 5];
                    case 5:
                        _i++;
                        return [3 /*break*/, 1];
                    case 6:
                        this.components = this.getComponents();
                        this.benefits = this.getBenefits();
                        this.amount = this.basketItem.amount.toString();
                        if (this.basketItem.offer.mandatoryServices[0].items) {
                            this.mandatoryServices =
                                this.basketItem.offer.mandatoryServices[0].items;
                        }
                        if (this.basketItem.offer.getUsedOptions()) {
                            this.usedOptions = this.modifyUseOptionsForInsurance(this.basketItem.offer.getUsedOptions());
                            this.usedOptions = this.usedOptions.filter(function (option) {
                                return option.description.additional.type !== "voucherBenefit" &&
                                    option.description.additional.type !==
                                        "onetimeVoucherBenefit";
                            });
                        }
                        if (this.basketItem.offer.getDiscounts()) {
                            this.discounts = this.basketItem.offer.getDiscounts();
                        }
                        if (this.basketItem.offer.getVoucherBenefits()) {
                            this.voucherBenefits = this.basketItem.offer.getVoucherBenefits();
                        }
                        if (this.basketItem.offer.getOnetimeVoucherBenefits()) {
                            this.onetimeVoucherBenefits =
                                this.basketItem.offer.getOnetimeVoucherBenefits();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketItemComponent.prototype.modifyUseOptionsForInsurance = function (options) {
        var myOptions = [];
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var option = options_1[_i];
            if (SERVICE_TYPE_DEVICE_INSURANCE ===
                option.description.additional.type) {
                this.insuranceOption.push(option);
            }
            else {
                myOptions.push(option);
            }
        }
        return myOptions;
    };
    BasketItemComponent.prototype.getBenefits = function () {
        var benefits = [];
        for (var _i = 0, _a = this.basketItem.offer.getServicesByType(SERVICE_TYPE_DATA_VOLUME_BENEFIT); _i < _a.length; _i++) {
            var benefit = _a[_i];
            benefits.push(VluxMarkup([benefit.description.label]));
        }
        return benefits;
    };
    BasketItemComponent.prototype.getOnetimeCashback = function () {
        for (var _i = 0, _a = this.basketItem.offer.getServicesByType("onetimeCashback"); _i < _a.length; _i++) {
            var service = _a[_i];
            var cashbackPriceSum = service.prices[0].value * this.basketItem.amount;
            var onetimeCashbackText = cashbackPriceSum + " &euro; " + service.description.label;
            return onetimeCashbackText;
        }
        return;
    };
    BasketItemComponent.prototype.formatOnetimeVoucherBenefit = function (benefit) {
        var voucherBenefitPriceSum = benefit.prices[0].value * this.basketItem.amount;
        var onetimeVoucherBenefitText = voucherBenefitPriceSum + " " + benefit.description.label;
        return onetimeVoucherBenefitText;
    };
    return BasketItemComponent;
}());
export { BasketItemComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/basket-overview/basket-item/basket-item.component.ts
// module id = null
// module chunks = 